<template>
  <div>
     <noscript>
      <strong>We're sorry but stockhey doesn't work properly without JavaScript enabled. Please enable it to continue.</strong>
    </noscript>
  <footer>
    <h5 class="bg-purple-light">友情链接</h5>
    <div class="xfooter">
    <a href="https://cn.vuejs.org/v2/guide/" target="_blank">Vue.js</a>
    <a href="https://koa.bootcss.com/" target="_blank">koa</a>
    <a href="https://echarts.apache.org/en/index.html" target="_blank">Echarts</a>
    <a href="https://splash.readthedocs.io/en/stable/" target="_blank">splash</a>
    <a href="https://scrapy.org/" target="_blank">scrapy</a>
    <a href="https://blog.whsasf.com" target="_blank">MyBlog</a>
    </div>
    <p class="bg-purple-light"><a href="http://beian.miit.gov.cn" target="_blank">沪ICP备19037220号-3</a></p>
  </footer>
  </div>
</template>
<script>
export default {
  name: 'Footer',
  components: {
  }
}
</script>
<style scoped>

footer{
  min-height: 70px;
  background-color: #D53A35;
  color: #aaa;
  font-size: 0.8em;
  margin-top: 20px;
  padding: 10px 0 0 0;
  line-height: 1.8em
}

@meaid(min-width: 500px){
  footer{
    padding: 0 15%;
  }
}
footer a {
  color: #c9c8ce;
  text-decoration:none;
  font-size:1.3em
}

.bg-purple-light a {
  font-size:1.1em
}
footer h5 {
  margin: 0
}

.xfooter {
  display: flex;
  justify-content: space-around
}

.bg-purple-light{
  text-align: center;
}
h5.bg-purple-light {
  font-size:1.4em
}
p.bg-purple-light {
  margin-bottom: 0
}
</style>
